module.exports = __webpack_public_path__ + "img/product-autoship-incentive.2715669.webp";